<template>
  <button
    type="button"
    class="charter-flight-button flex items-center justify-between space-x-3 rounded-2xl p-3"
    @click="emit('onClick')"
  >
    <span class="flex items-center space-x-3">
      <span
        class="text-3xs rounded bg-purple-700 px-1.5 py-1 font-bold uppercase text-white"
      >
        {{ t('charter.charter') }}
      </span>
      <span class="text-text-neutral-primary text-xs">
        {{ t('charter.whatIsCharterFlight') }}
      </span>
    </span>
    <img
      src="./assets/chevron-right-purple.svg"
      width="20"
      height="20"
      alt=""
    />
  </button>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  const { t } = useI18n();

  const emit = defineEmits<{
    onClick: [];
  }>();
</script>

<style scoped>
  .charter-flight-button {
    background-color: rgb(var(--background-neutral-secondary));
    background-image: linear-gradient(
      0deg,
      rgba(161, 22, 146, 0.1),
      rgba(161, 22, 146, 0.1)
    );
  }
</style>

<i18n src="../locales.json" />
